import { type ContactFilters__Input, ConnectorOperator } from '~/graphql/types';
import { emptyFilterGroupV2 } from '~/components/page/Contacts/components/ContactList/FilterBar';

export const DEFAULT_EMPTY_FILTERS: ContactFilters__Input = {
  connector: ConnectorOperator.And,
  negate: false,
  nodes: [emptyFilterGroupV2()],
};
